import { render, staticRenderFns } from "./PromptDialog.vue?vue&type=template&id=9f52bb22&scoped=true"
import script from "./PromptDialog.vue?vue&type=script&lang=js"
export * from "./PromptDialog.vue?vue&type=script&lang=js"
import style0 from "./PromptDialog.vue?vue&type=style&index=0&id=9f52bb22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f52bb22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f52bb22')) {
      api.createRecord('9f52bb22', component.options)
    } else {
      api.reload('9f52bb22', component.options)
    }
    module.hot.accept("./PromptDialog.vue?vue&type=template&id=9f52bb22&scoped=true", function () {
      api.rerender('9f52bb22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Guide/components/SetupWizard/PromptDialog.vue"
export default component.exports